export default class InfiniteScroller {
  constructor() {
    /*fetch('/wp-json/wp/v2/post-verkooppunten')
      .then((r) => r.json())
      .then((r) => {
        console.log(r);
      });*/
  }
}
